export default __webpack_public_path__ + "static/media/incubator.8820f6d0.svg";